import { FeatureFlagName } from "../utils/featureFlagName";

/**
 * Internal (Geotab-hosted) addins that are injected alongside customer addins.
 * Previously lived as a static property on DatabaseCache — moved here as pure config.
 */
export interface IInternalAddinConfig {
    url: string;
    featureFlag: FeatureFlagName;
    viewSecurityIdentifier: string;
}

export const defaultInternalAddins: IInternalAddinConfig[] = [
    // Routes Connect addin
    {
        url: "https://app.geotab.com/addins/geotab/route-connect/manifest.json",
        featureFlag: FeatureFlagName.ROUTE_CONNECT_ADDIN,
        viewSecurityIdentifier: "ViewRoute"
    }
];
